"use client"

import { useEffect, useState } from "react"

export function useTopnavScroll() {
  const [y, setY] = useState(0)

  useEffect(() => {
    let ticking = false

    const onScroll = () => {
      if (!ticking) {
        window.requestAnimationFrame(() => {
          setY(window.scrollY || 0)
          ticking = false
        })
        ticking = true
      }
    }

    window.addEventListener("scroll", onScroll, { passive: true })

    return () => window.removeEventListener("scroll", onScroll)
  }, [])

  return {
    y,
    progress: Math.min(y / 180, 1), // 0 → 1 (clave del efecto Apple Music)
  }
}